<template lang="html">
  <div class="vip-head">
    <img class="vip-head-bg" @click="$emit('showChoice')" v-if="isBuy" src="./images/head.png" alt="">
    <img class="vip-head-bg" v-else src="./images/head-no.png" alt="">
    <div class="vip-head-info">
      <slot name="userPic"></slot>
      <p><slot name="userName"></slot></p>
    </div>
    <!--<div class="vip-head-info"></div>-->
    <div class="vip-head-into">
      <slot name="endDate"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VipHead',
  props: ['isBuy']
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.vip-head {
  width: 100%;
  position: relative;
  &-bg {
    width: 100%;
  }
  &-info {
    position: absolute;
    top: rem(70);
    left: rem(86);
    height: rem(90);
    display: flex;
    align-items: center;
    img {
      width: rem(90);
      border-radius: 100%;
    }
    p {
      font-size: rem(32);
      font-weight: bolder;
      color: #fff;
      margin-left: rem(20);
    }
  }
  &-into {
    position: absolute;
    top: rem(188);
    left: rem(90);
    font-size: rem(26);
    color: #fff;
  }
}
</style>
